export const phoneReg = /^[18]\d{10}$/; // 字数限制为11，不需要+86，8开头的是测试账号，验证码统一为0000
export const telReg = /^400([0-9]){7}$/;
export const moneyReg = /^\d*\.?\d{1,2}?$/;
export const pwdReg = /^(?=.*[0-9])(?=.*[a-zA-Z])[^]{6,15}$/;
export const httpReg = /^(http|https):\/\/([\w.]+\/?)\S*/;
export const timeReg = /^(?:19|20)[0-9][0-9]-(?:19|20)[0-9][0-9]$/; // 执业经历时间
